import { getAvailableFields } from 'shared/domain/visibleField/availableFields';
import { HashMap } from 'shared/types/commonView';
import { Process } from 'shared/domain/process/types/model';
import { VisibleFieldModel } from './visibleFieldModel';

export function toVisibleFieldModelMap(
  fields: HashMap<VisibleFieldModel[]>
): HashMap<HashMap<boolean>> {
  const initialFields = getInitialFields();
  const mapped = Object.keys(fields).reduce(
    (result, key) => {
      fields[key].forEach((field) => {
        result[key][field.fieldName] = true;
      });
      return result;
    },
    {
      [Process.HS]: { ...initialFields[Process.HS] },
      [Process.QA]: { ...initialFields[Process.QA] },
      [Process.ENV]: { ...initialFields[Process.ENV] },
      [Process.TSK]: { ...initialFields[Process.TSK] },
      [Process.MS]: { ...initialFields[Process.MS] },
      [Process.MSC]: { ...initialFields[Process.MSC] },
      [Process.MSS]: { ...initialFields[Process.MSS] },
      [Process.MSE]: { ...initialFields[Process.MSE] },
      [Process.RFI]: { ...initialFields[Process.RFI] },
      [Process.CO]: { ...initialFields[Process.CO] },
      [Process.NO]: { ...initialFields[Process.NO] },
      [Process.ACC]: { ...initialFields[Process.ACC] },
      [Process.DS]: { ...initialFields[Process.DS] },
    }
  );

  return mapped;
}

function getInitialFields(): HashMap<HashMap<boolean>> {
  const result = {
    [Process.HS]: {},
    [Process.QA]: {},
    [Process.ENV]: {},
    [Process.TSK]: {},
    [Process.MS]: {},
    [Process.MSC]: {},
    [Process.MSS]: {},
    [Process.MSE]: {},
    [Process.RFI]: {},
    [Process.CO]: {},
    [Process.NO]: {},
    [Process.ACC]: {},
    [Process.DS]: {},
  };
  getAvailableFields().forEach((field) => {
    if (!field.canBeDisabled) {
      field.processes.forEach((process) => {
        result[process][field.fieldName] = true;
      });
    }
  });
  return result;
}
